import { Directive, Input, ElementRef, Renderer2, OnInit, OnDestroy, HostListener, Optional } from '@angular/core';
import { PlessTitleWindowDirective } from '../../shared/pless-title-window.directive';
import { CdkDrag } from '@angular/cdk/drag-drop';


@Directive({
  selector: 'table[plessTitleWindowSub], div[plessTitleWindowSub]',
})

/**
 * ウインドウ表示機能を提供するディレクティブ
 */
export class PlessTitleWindowSubDirective extends PlessTitleWindowDirective implements OnInit, OnDestroy {

  /** フォーカス設定可能なエレメント */
  protected tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
    'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']),' +
    ' textarea:not([disabled]):not([tabindex=\'-1\']), iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';

  /** 最前面表示フラグ */
  @Input() frontDispFlag = true;

  /** tabindex保存用エレメントリスト */
  protected defaultDocumentElements: Array<any> = new Array<any>();

  /** 全体エレメントリスト */
  protected documentElements: any = null;
  /** 対象画面エレメントリスト */
  protected elements: any = null;
  /** 対象画面エレメントリスト（ソート） */
  protected sortElements: Array<any> = new Array<any>();
  /** 対象画面エレメントリスト（tabindex=0） */
  protected elementsIndex0: Array<any> = new Array<any>();

  constructor(protected elementRef: ElementRef, protected renderer: Renderer2,
    @Optional() protected cdkDrag: CdkDrag) {
    super(elementRef, renderer, cdkDrag);
  }

  ngOnInit() {
    super.ngOnInit();

    setTimeout(() => {
      this.documentElements = <any>document.querySelectorAll(this.tabbableSelector);
      this.elements = this.elementRef.nativeElement.querySelectorAll(this.tabbableSelector);

      // 自画面以外の要素のtabindexを-1に設定
      this.documentElements.forEach(element => {
        let existFlg = Boolean(false);
        for (let i = Number(0); i < this.elements.length; i++) {
          if (this.elements[i] === element) {
            existFlg = true;
            break;
          }
        }
        // 自画面以外のtabindex復元用にリストに追加
        if (!existFlg) {
          this.defaultDocumentElements.push({ element: element, tabindex: element.tabIndex });
          element.tabIndex = -1;
        }
      });
    });
  }

  ngOnDestroy() {
    // 自画面以外の要素のtabindexをもとに戻す
    this.defaultDocumentElements.forEach(data => {
      data.element.tabIndex = data.tabindex;
    });
    this.defaultDocumentElements = new Array<any>();
  }

  /** キーダウン時の処理 */
  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // TABキーによるフォーカス制御
    if (event.key !== 'Tab') {
      return;
    }
    this.elements = this.elementRef.nativeElement.querySelectorAll(this.tabbableSelector);
    // 項番2231 START 障害管理NO.I00380対応
    // this.sortElements = new Array<any>();
    // 項番2231 END 障害管理NO.I00380対応
    this.elementsIndex0 = new Array<any>();

    // 対象画面の要素をソート用配列に格納
    this.elements.forEach(element => {
      // 項番2231 START 障害管理NO.I00380対応
      // if (element.tabIndex === 0) {
      //   // tabindex=0の要素はソート後リストの後ろに追加
      //   this.elementsIndex0.push({ element: element, tabindex: element.tabIndex });
      // } else {
      //   this.sortElements.push({ element: element, tabindex: element.tabIndex });
      // }
      // tabindexが0で活性のもののリスト
      // if (element.tabIndex === 0 && !element.disabled && element.className !== 'wj-form-control') {
      if (element.tabIndex === 0 && !element.disabled && element.className !== 'wj-form-control' && element.style.display !== 'none') {
        // 項番2231 END 障害管理NO.I00380対応
        this.elementsIndex0.push({ element: element, tabindex: element.tabIndex });
        // 項番2231 START 障害管理NO.I00380対応
        // } else {
        //   this.sortElements.push({ element: element, tabindex: element.tabIndex });
        // 項番2231 END 障害管理NO.I00380対応
      }
    });
    // 対象画面の要素をソート
    // 項番2231 START 障害管理NO.I00380対応
    // this.sortElements.sort(function (a, b) {
    this.elementsIndex0.sort(function (a, b) {
      // 項番2231 END 障害管理NO.I00380対応
      if (a.tabindex < b.tabindex) {
        return -1;
      }
      if (a.tabindex > b.tabindex) {
        return 1;
      }
      return 0;
    });
    // 項番2231 START 障害管理NO.I00380対応
    // this.sortElements = this.sortElements.concat(this.elementsIndex0);
    // 項番2231 END 障害管理NO.I00380対応

    let focusChanged = Boolean(false);
    // Shiftキー押下チェック
    if (event.shiftKey) {
      // 最初の項目かどうか
      // 項番2231 START 障害管理NO.I00380対応
      // if (isFocusInFirstItem(event, this.sortElements)) {
      //   focusChanged = focusLastFocusableElement(this.sortElements);
      if (isFocusInFirstItem(event, this.elementsIndex0)) {
        focusChanged = focusLastFocusableElement(this.elementsIndex0);
        // 項番2231 END 障害管理NO.I00380対応
      }
    } else {
      // 最後の項目かどうか
      // 項番2231 START 障害管理NO.I00380対応
      // if (isFocusInLastItem(event, this.sortElements)) {
      //   focusChanged = focusFirstFocusableElement(this.sortElements);
      if (isFocusInLastItem(event, this.elementsIndex0)) {
        focusChanged = focusFirstFocusableElement(this.elementsIndex0);
        // 項番2231 END 障害管理NO.I00380対応
      }
    }

    if (focusChanged) {
      event.preventDefault();
      event.stopPropagation();
    }

    // フォーカス設定可能な項目の内、最初の項目かどうかを判定する
    function isFocusInFirstItem(evt, list) {
      if (list.length > 0) {
        return (evt.target || evt.srcElement) === list[0].element;
      }
      return false;
    }
    // フォーカス設定可能な項目の内、最後の項目かどうかを判定する
    function isFocusInLastItem(evt, list) {
      if (list.length > 0) {
        return (evt.target || evt.srcElement) === list[list.length - 1].element;
      }
      return false;
    }
    // フォーカス設定可能な項目の内、最初の項目にフォーカスを設定する
    function focusFirstFocusableElement(list) {
      if (list.length > 0) {
        // 項番2231 START 障害管理NO.I00380対応
        // list[0].element.focus();
        for (let i: number = <number>0; i < list.length; i++) {
          if (!list[i].element.disabled) {
            list[i].element.focus();
            // 項番2231 END 障害管理NO.I00380対応
            return true;
          }
          // 項番2231 START 障害管理NO.I00380対応
        }
      }
      // 項番2231 END 障害管理NO.I00380対応
      return false;
    }
    // フォーカス設定可能な項目の内、最後の項目にフォーカスを設定する
    function focusLastFocusableElement(list) {
      if (list.length > 0) {
        // 項番2231 START 障害管理NO.I00380対応
        // list[list.length - 1].element.focus();
        // list[list.length - 1].element.focus();
        for (let i: number = list.length - 1; i > 0; i--) {
          if (!list[i].element.disabled) {
            list[i].element.focus();
            // 項番2231 END 障害管理NO.I00380対応
            return true;
          }
          // 項番2231 START 障害管理NO.I00380対応
        }
      }
      // 項番2231 END 障害管理NO.I00380対応
      return false;
    }
  }

  /* ============================================================
      ウインドウの表示(前面・背面)に関する処理
  ============================================================ */

  /** クリック時の処理 */
  @HostListener('mousedown', ['$event'])
  handleClick(event: MouseEvent) {
    // Windowを最前面に移動
    if (this.frontDispFlag === true) {
      this.bringToFront();
    }
  }

}
